import { z } from 'zod';
import {requiredText} from "~/common/utils/schemaUtil.ts";

export const createTemplateSchema = z.object({
  name: requiredText(40)
});